import { SET_MIQ_AMENITIES, MIQAmenity, SetMiqAmenitiesAction } from '../../actions/system/load-miq-amenities';

export interface MiqAmenitiesCacheState {
    [cacheKey: string]: MIQAmenity[];
}

type MiqAmenitiesAction = SetMiqAmenitiesAction | { type: 'CLEAR_MIQ_AMENITIES_CACHE' };

const initialState: MiqAmenitiesCacheState = {};

export default (state = initialState, action: MiqAmenitiesAction): MiqAmenitiesCacheState => {
    switch (action.type) {
        case SET_MIQ_AMENITIES:
            return {
                ...state,
                [action.payload.cacheKey]: Array.isArray(action.payload.amenities) ? action.payload.amenities : []
            };
        case 'CLEAR_MIQ_AMENITIES_CACHE':
            return {};
        default:
            return state;
    }
};
